import { ButtonStyles, borderRadiusMedium, colorNeutralForegroundOnBrand, colorStrokeFocus2, shadow2, colorNeutralStrokeOnBrand, colorBrandBackground, colorBrandBackgroundHover, colorBrandBackgroundPressed } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${ButtonStyles}

  /* Override Fluent UI small size border-radius to use borderRadiusMedium */
  :host([size="small"]:not([shape="circular"]):not([shape="square"])) {
    border-radius: ${borderRadiusMedium};
  }

  :host([appearance="primary-on-brand"]) {
    background-color: ${colorBrandBackground};
    color: ${colorNeutralForegroundOnBrand};
    border-color: ${colorNeutralStrokeOnBrand};
  }

  :host(
    [appearance="primary-on-brand"]:is(:hover, :hover:active):not(
        :focus-visible
      )
  ) {
    border-color: ${colorNeutralStrokeOnBrand};
  }

  :host([appearance="primary-on-brand"]:is(:hover, :hover:active)) {
    color: ${colorNeutralForegroundOnBrand};
    background-color: ${colorBrandBackgroundHover};
  }

  :host([appearance="primary-on-brand"]:hover:active) {
    background-color: ${colorBrandBackgroundPressed};
  }

  :host([appearance="primary-on-brand"]:focus-visible) {
    border-color: ${colorNeutralForegroundOnBrand};
    box-shadow:
      ${shadow2},
      0 0 0 2px ${colorStrokeFocus2};
  }
`;
//# sourceMappingURL=button.styles.js.map